import { render, staticRenderFns } from "./WorkoutExercise.vue?vue&type=template&id=238cfa12&scoped=true"
import script from "./WorkoutExercise.vue?vue&type=script&lang=js"
export * from "./WorkoutExercise.vue?vue&type=script&lang=js"
import style0 from "./WorkoutExercise.vue?vue&type=style&index=0&id=238cfa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238cfa12",
  null
  
)

export default component.exports